import { FC } from 'react'

const PaypalIcon: FC = () => (
  <svg
    width="41"
    height="26"
    viewBox="0 0 41 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.609375"
      y="1"
      width="39"
      height="24"
      rx="3.5"
      fill="#F5F6F8"
    />
    <rect
      x="0.609375"
      y="1"
      width="39"
      height="24"
      rx="3.5"
      stroke="#E5E5EA"
    />
    <path
      d="M16.8797 20.5828L17.1586 18.807L16.5359 18.793H13.5625L15.6289 5.68985C15.6351 5.64983 15.6555 5.61337 15.6863 5.58712C15.7171 5.56087 15.7564 5.54659 15.7969 5.54688H20.8109C22.475 5.54688 23.6234 5.89297 24.2234 6.57657C24.5047 6.89688 24.6844 7.23282 24.7703 7.60157C24.8609 7.98829 24.8633 8.45079 24.7742 9.01485L24.768 9.05625V9.41719L25.0492 9.57657C25.2633 9.68594 25.4563 9.83204 25.618 10.0109C25.8586 10.2844 26.0141 10.6336 26.0797 11.0461C26.1477 11.4711 26.1258 11.9773 26.0141 12.5492C25.8859 13.2078 25.6781 13.782 25.3984 14.2508C25.1513 14.6714 24.8189 15.0357 24.4227 15.3203C24.0248 15.5964 23.5797 15.7971 23.1094 15.9125C22.5722 16.0449 22.0204 16.1087 21.4672 16.1023H21.0766C20.7977 16.1023 20.5266 16.2031 20.3141 16.3836C20.1017 16.5655 19.9608 16.8169 19.9164 17.093L19.8867 17.2531L19.393 20.3828L19.3711 20.4977C19.3648 20.5336 19.3547 20.5523 19.3398 20.5641C19.3253 20.576 19.3071 20.5826 19.2883 20.5828H16.8797Z"
      fill="#253B80"
    />
    <path
      d="M25.3241 9.10156C25.3091 9.19981 25.2922 9.29774 25.2733 9.39531C24.6124 12.7906 22.3499 13.9633 19.4608 13.9633H17.9897C17.8192 13.9631 17.6543 14.024 17.5247 14.1349C17.3952 14.2458 17.3096 14.3994 17.2835 14.568L16.5304 19.3445L16.3171 20.6984C16.3086 20.7522 16.3119 20.8071 16.3267 20.8595C16.3415 20.9118 16.3675 20.9603 16.4028 21.0017C16.4381 21.043 16.482 21.0762 16.5314 21.099C16.5808 21.1218 16.6346 21.1336 16.689 21.1336H19.2983C19.4476 21.1334 19.5919 21.0801 19.7055 20.9832C19.819 20.8863 19.8943 20.7521 19.9179 20.6047L19.9436 20.4719L20.4351 17.3547L20.4663 17.1828C20.4896 17.0351 20.5649 16.9005 20.6786 16.8034C20.7924 16.7063 20.9371 16.653 21.0866 16.6531H21.4772C24.0046 16.6531 25.9827 15.6273 26.5616 12.657C26.803 11.4164 26.678 10.3805 26.0382 9.65234C25.8358 9.42698 25.5933 9.24035 25.3241 9.10156Z"
      fill="#179BD7"
    />
    <path
      d="M24.6305 8.82363C24.4194 8.76248 24.2046 8.71473 23.9875 8.68066C23.5584 8.61475 23.1247 8.58314 22.6906 8.58613H18.7609C18.6114 8.58604 18.4667 8.63947 18.353 8.73676C18.2394 8.83405 18.1643 8.96878 18.1414 9.1166L17.3055 14.4111L17.2812 14.5658C17.3074 14.3973 17.3929 14.2437 17.5225 14.1328C17.652 14.0219 17.817 13.961 17.9875 13.9611H19.4586C22.3477 13.9611 24.6094 12.7877 25.2711 9.39316C25.2906 9.29316 25.307 9.19473 25.3219 9.09941C25.1018 8.98333 24.87 8.89089 24.6305 8.82363Z"
      fill="#222D65"
    />
    <path
      d="M18.139 9.11562C18.1618 8.96781 18.2369 8.83308 18.3505 8.73589C18.4642 8.6387 18.609 8.5855 18.7585 8.58594H22.6882C23.1538 8.58594 23.5882 8.61641 23.9851 8.67969C24.2534 8.72198 24.518 8.7852 24.7765 8.86875C24.9718 8.93359 25.1531 9.00937 25.3202 9.09844C25.5171 7.84375 25.3187 6.98906 24.6406 6.21563C23.8921 5.36406 22.5429 5 20.8156 5H15.8015C15.6307 4.99999 15.4655 5.06099 15.3358 5.172C15.206 5.28302 15.1201 5.43674 15.0937 5.60547L13.0054 18.843C12.9956 18.9045 12.9992 18.9674 13.016 19.0273C13.0329 19.0873 13.0625 19.1429 13.1029 19.1902C13.1433 19.2376 13.1935 19.2757 13.2501 19.3018C13.3066 19.3279 13.3681 19.3414 13.4304 19.3414H16.5257L17.3031 14.4102L18.139 9.11562Z"
      fill="#253B80"
    />
  </svg>
)

export default PaypalIcon
